<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" v-for="estimacion in estimacionesPorSedes" :key="estimacion.sede_id">
        <h3 class="h5">{{ estimacion.sede }}</h3>
        <v-simple-table dense style="border: 1px solid #d1d1d1">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left caption">CUENTA</th>
                <th class="text-left caption">CONTABLE</th>
                <th class="text-right caption">SUBTOTAL GESTIÓN</th>
                <th class="text-right caption">DESERCIÓN GESTIÓN</th>
                <th class="text-right caption">TOTAL GESTIÓN</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="detalle in estimacion.estimaciones_partidas" :key="`${estimacion.sede_id}${detalle.codigo}`">
                <td class="text-left caption">{{ detalle.codigo }} {{ detalle.clasificador_nombre }}</td>
                <td class="text-left caption">
                  {{ detalle.cuenta_contable_codigo }} {{ detalle.cuenta_contable_nombre }}
                </td>
                <td class="text-right caption">{{ formatearNumero(detalle.subtotal_gestion) }}</td>
                <td class="text-right caption">{{ formatearNumero(detalle.desercion_gestion) }}</td>
                <td class="text-right caption">{{ formatearNumero(detalle.total_gestion) }}</td>
              </tr>
              <tr>
                <td></td>
                <td class="text-left caption">TOTALES</td>
                <td class="text-right caption font-weight-bold">
                  {{
                    formatearNumero(
                      estimacion.estimaciones_partidas
                        .reduce((a, b) => a + parseFloat(b.subtotal_gestion), 0)
                        .toFixed(2),
                    )
                  }}
                </td>
                <td class="text-right caption font-weight-bold">
                  {{
                    formatearNumero(
                      estimacion.estimaciones_partidas
                        .reduce((a, b) => a + parseFloat(b.desercion_gestion), 0)
                        .toFixed(2),
                    )
                  }}
                </td>
                <td class="text-right caption font-weight-bold">
                  {{
                    formatearNumero(
                      estimacion.estimaciones_partidas.reduce((a, b) => a + parseFloat(b.total_gestion), 0).toFixed(2),
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { formatearNumero } from './../../utils.js';

export default {
  name: 'ReportePorSedes',
  props: {
    estimacionesPorSedes: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    formatearNumero(numero) {
      if (numero) {
        return formatearNumero(numero);
      }

      return 0.0;
    },
  },
};
</script>

<style>
</style>